import * as yup from "yup"
import validationMessages from "@utils/validation/messages"

const phoneRequired = () => yup.string()
    .required(validationMessages.phoneError)
    .min(10, validationMessages.phoneError)
    .max(10, validationMessages.phoneError)
    .matches(/^[0-9]*$/, validationMessages.phoneError)

export default phoneRequired